import React from "react";

const ContactMe = () => {
  return (
    <React.Fragment>
      <div className="contactme" id="contactme">
        <div className="container">
          <h1>Mail Id</h1> <p>shelcia1999@gmail.com</p>
          <h1>Number</h1>
          <p>8248578522</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactMe;
